var _path, _rect, _path2, _path3, _path4, _path5, _rect2, _rect3, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcOpinionServiceMainMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 107,
    viewBox: "0 0 131 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.4451 20.6419L21.5937 39.1286L50.7635 54.9429L70.4183 32.2782C70.4183 32.2782 79.0988 33.1877 80.0656 33.3644C86.8928 34.6116 92.3805 31.5851 95.9258 28.2782C97.9715 26.3702 96.64 23.3167 93.8827 22.8445L68.4068 18.4819C63.9663 17.7215 59.3991 18.4826 55.4451 20.6419Z",
    fill: "#FFDCD5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 46.7119,
    y: 5.40723,
    width: 95,
    height: 10,
    transform: "rotate(33.9563 46.7119 5.40723)",
    fill: "#3A7EFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6465 43.2979L108.382 31.4843C111.664 31.0268 114.695 33.3164 115.153 36.5984L115.347 37.9928C115.805 41.2748 113.515 44.3062 110.233 44.7638L25.4979 56.5773L23.6465 43.2979Z",
    fill: "#FFDCD5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2705 51.8262L98.7928 49.3512C102.105 49.2397 104.88 51.8341 104.991 55.1459L105.076 57.6697C105.188 60.9815 102.593 63.7567 99.2814 63.8682L25.7592 66.3432L25.2705 51.8262Z",
    fill: "#FFDCD5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3945 66.3545L93.1712 64.0729C96.483 63.9614 99.2582 66.5558 99.3697 69.8677L99.417 71.2748C99.5285 74.5866 96.9341 77.3617 93.6223 77.4732L25.8456 79.7548L25.3945 66.3545Z",
    fill: "#FFDCD5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3076 79.7725L90.1521 77.5896C93.464 77.4781 96.2391 80.0725 96.3506 83.3843L96.398 84.7914C96.5095 88.1033 93.9151 90.8784 90.6032 90.9899L25.7587 93.1728L25.3076 79.7725Z",
    fill: "#FFDCD5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.7715,
    y: 41.2725,
    width: 67.7839,
    height: 25.7484,
    transform: "rotate(-2.3439 17.7715 41.2725)",
    fill: "#FFDCD5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 24.5811,
    height: 64.597,
    rx: 4,
    transform: "matrix(-0.999997 0.00244765 0.00244765 0.999997 27.1279 31.3945)",
    fill: "#374969"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M130.178 67.6488L119.918 66.7729L125.509 58.4706L130.178 67.6488Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOpinionServiceMainMobile);
export default __webpack_public_path__ + "static/media/IcOpinionServiceMainMobile.971ff2945c7ca6bbb6d4f2b1936d535c.svg";
export { ForwardRef as ReactComponent };